module.exports = __webpack_public_path__ + "static/content-d5087694f8e31c9f8dba6853d62764e6.svg";